import { __assign } from "tslib";
import React from 'react';
import { StyledChip } from './styled';
export var Chip = React.forwardRef(function (props, ref) {
    return React.createElement(StyledChip, __assign({}, props, { ref: ref }));
});
Chip.displayName = "Chip";
// MUI Chip 는 기본으로 임포트 해서 사용할 수 있도록 함
// Chip 가 여러개가 하나의 디자인을 가질 경우 , 해당 이름을 가진 Chip 로 묶어두고 사용
//# sourceMappingURL=chip.js.map